import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function headerButton() {
  const widgetName = 'headerButton';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof headerButtonOpts === 'undefined' ? null : headerButtonOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createHeaderButton(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createHeaderButton(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      missingWidget(widgetName);
      $widget.remove();
      return;
    }
    $widget.find('.card-widget-item').replaceWith(
      `<a class="button" tabindex="0" href="${URL}" ${updateLinksAttributes(URL, Title)} aria-label="${Title}">
            <span class="btn-label">${Title}</span>
          </a>`,
    );
  }
}
